import { useFocusEffect, useGlobalSearchParams } from 'expo-router';
import { useAcceptChallenge } from 'features/auth/hooks/useAcceptChallenge';
import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import FullScreenLoading from 'shared/components/vxl/loading/FullScreenLoading/FullScreenLoading';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';

type AcceptChallengeParams = {
  identityId: string;
  code: string;
  challengeId: string;
  emailAddress: string;
};

const AcceptOneFA = () => {
  const { acceptChallenge, isLoading: isAcceptChallengeLoading } =
    useAcceptChallenge();

  const { identityId, code, challengeId, emailAddress } =
    useGlobalSearchParams<AcceptChallengeParams>();

  const onCodeSubmitAction = useCallback(() => {
    // checking challengeId to avoid unnecessary API call which required challengeId as parameter
    if (challengeId) {
      void acceptChallenge({
        challengeId: challengeId,
        otpCode: code,
        identityId: identityId,
        email: emailAddress ?? '',
      });
    }
  }, [challengeId, acceptChallenge, code, identityId, emailAddress]);

  useFocusEffect(
    useCallback(() => {
      void onCodeSubmitAction();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  return (
    <View style={styles.container}>
      <ScreenTransitionOverlay
        isLoading={isAcceptChallengeLoading}
        LoadingComponent={<FullScreenLoading isCoinLoader />}
        ErrorComponent={null}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default AcceptOneFA;
